import React, { ReactElement, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DropshipperTableItem from './DropshipperTableItem';
import Context from '../../../../../../context';
import GraphQLTable from '../../../../../../components/_table/GraphQLTable';
import {
  IDropshippingRequestCompanyQueryData,
  IDropshippingRequestCompanyVars,
  useDropshippingRequestCompanyQuery,
} from '../../../../../../../graphql/query/dropshippingRequestCompany/useDropshippingRequestCompanyQuery';
import { IDropshippingRequestCompanySchema } from '../../../../../../../graphql/type/dropshippingRequestCompany';
import ButtonDisapproveDropshipper from '../ButtonDisapproveDropshipper';
import Helmet from '../../../../../../components/Helmet';
import DROPSHIPPING_REQUEST_COMPANY from '../../../../../../components/constant/dropshippingRequestCompany';
import ButtonApproveDropshipper from '../ButtonApproveDropshipper';

interface IProps {
  status?: string;
}

export default function DropshipperTable(props: IProps) {
  const { status } = props;
  const { t } = useTranslation();
  const { company } = useContext(Context);
  const [tableRefreshKey, setTableRefreshKey] = useState<number>(0);
  const [selectedItems, setSelectedItems] = useState<
    IDropshippingRequestCompanySchema[]
  >([]);

  let title: string = '';
  let actionButtons: ReactElement[] = [];
  const ButtonDisapprove = (
    <ButtonDisapproveDropshipper
      key="disapproveDropshipper"
      size="small"
      requestIds={selectedItems.map((selectedItem) => selectedItem._id)}
      onSuccess={() => {
        setSelectedItems([]);
      }}
    />
  );
  const ButtonApprove = (
    <ButtonApproveDropshipper
      key="approveDropshipper"
      size="small"
      requestIds={selectedItems.map((selectedItem) => selectedItem._id)}
      onSuccess={() => {
        setSelectedItems([]);
      }}
    />
  );

  if (status === DROPSHIPPING_REQUEST_COMPANY.STATUS.APPROVED) {
    title = t('approved_dropshipper_list');
    actionButtons = [ButtonDisapprove];
  } else if (status === DROPSHIPPING_REQUEST_COMPANY.STATUS.DISAPPROVED) {
    title = t('disapproved_dropshipper_list');
    actionButtons = [ButtonApprove];
  } else if (status === DROPSHIPPING_REQUEST_COMPANY.STATUS.PENDING) {
    title = t('pending_dropshipper_list');
    actionButtons = [ButtonApprove, ButtonDisapprove];
  }

  return (
    <>
      <Helmet title={`${title} | ${t('product')}`} />
      <GraphQLTable<
        IDropshippingRequestCompanyQueryData,
        IDropshippingRequestCompanySchema,
        IDropshippingRequestCompanyVars
      >
        refreshKey={tableRefreshKey}
        select={`
				_id
				from_company_id
				fromCompanyData {
				    _id
					origin
					verification
					slug
					name {
                        la
                        text
                    }
				}
				status 
				created {
					time 
				}
       	 `}
        useQuery={useDropshippingRequestCompanyQuery}
        renderHeader={[
          {
            field: '_id',
            label: t('id'),
            align: 'left',
            sortable: true,
          },
          {
            field: 'name',
            label: t('company'),
            align: 'left',
          },
          {
            field: 'origin',
            label: t('origin'),
            align: 'center',
          },
          {
            field: 'status',
            label: t('status'),
            align: 'center',
          },
          {
            field: 'createdTime',
            label: t('created'),
            align: 'center',
            sortable: true,
          },
        ]}
        renderItem={(item) => (
          <DropshipperTableItem
            item={item}
            setTableRefreshKey={setTableRefreshKey}
          />
        )}
        useCheckbox
        onItemSelected={setSelectedItems}
        selectedItems={selectedItems}
        defaultFilterOptions={{
          toCompanyId: company._id,
          status,
        }}
        searchFields={{
          _id: { label: t('id') },
        }}
        title={title}
        defaultSort="createdTime"
        defaultSortOrder={-1}
        itemKey="_id"
        actionButtons={actionButtons}
      />
    </>
  );
}
